import { c as _c } from "react/compiler-runtime";
import { LabelWithHelp } from "@components/common/label-with-help";
import { ExternalLinks } from "@components/external-links";
import { FontWeights, SingleSelectAutocomplete } from "@flat-ui";
import { formatUserRoleType, userRoleDescription } from "@utils/data-display";
import { useMemo } from "react";
export function RoleAutocomplete(t0) {
  const $ = _c(30);
  const {
    selectedRole,
    onChange,
    onResetSelection,
    placeholder: t1,
    roles,
    disabledRoles: t2,
    link,
    labelTitle,
    isRequired: t3,
    isDisabled: t4,
    dataTestId
  } = t0;
  const placeholder = t1 === undefined ? "Select a role..." : t1;
  let t5;
  if ($[0] !== t2) {
    t5 = t2 === undefined ? [] : t2;
    $[0] = t2;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const disabledRoles = t5;
  const isRequired = t3 === undefined ? false : t3;
  const isDisabled = t4 === undefined ? false : t4;
  let t6;
  if ($[2] !== roles) {
    t6 = roles.map(_temp);
    $[2] = roles;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const roleOptions = t6;
  let t7;
  if ($[4] !== roleOptions || $[5] !== selectedRole) {
    t7 = roleOptions.find(option => option.value === selectedRole) ?? null;
    $[4] = roleOptions;
    $[5] = selectedRole;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const selectedValue = t7;
  let t8;
  if ($[7] !== onChange || $[8] !== onResetSelection) {
    t8 = function onSelectedRoleChanged(newValue) {
      if (newValue && typeof newValue === "object") {
        onChange(newValue.value);
      } else {
        if (onResetSelection) {
          onResetSelection();
        }
      }
    };
    $[7] = onChange;
    $[8] = onResetSelection;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const onSelectedRoleChanged = t8;
  let t9;
  if ($[10] !== isRequired || $[11] !== labelTitle) {
    t9 = labelTitle && <LabelWithHelp title={labelTitle} isRequired={isRequired} />;
    $[10] = isRequired;
    $[11] = labelTitle;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = !isRequired;
  let t11;
  if ($[13] !== disabledRoles) {
    t11 = option_0 => disabledRoles.includes(option_0.value);
    $[13] = disabledRoles;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== link) {
    t12 = link ? <ExternalLinks link={link} text="Learn about permissions levels" sx={{
      display: "flex",
      alignItems: "flex-start",
      fontSize: "11px",
      fontWeight: FontWeights.SemiBold,
      gap: "12px",
      padding: "8px",
      flex: "1 0 0",
      color: "primary.main"
    }} /> : undefined;
    $[15] = link;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== dataTestId || $[18] !== isDisabled || $[19] !== onSelectedRoleChanged || $[20] !== placeholder || $[21] !== roleOptions || $[22] !== selectedValue || $[23] !== t10 || $[24] !== t11 || $[25] !== t12) {
    t13 = <SingleSelectAutocomplete showIcon={false} isReadOnlyInput={true} showSelectedCheckmark={true} placeholder={placeholder} value={selectedValue} options={roleOptions} dataTestId={dataTestId} isClearable={t10} isDisabled={isDisabled} onChange={onSelectedRoleChanged} getOptionDisabled={t11} paperFooter={t12} />;
    $[17] = dataTestId;
    $[18] = isDisabled;
    $[19] = onSelectedRoleChanged;
    $[20] = placeholder;
    $[21] = roleOptions;
    $[22] = selectedValue;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t13 || $[28] !== t9) {
    t14 = <>{t9}{t13}</>;
    $[27] = t13;
    $[28] = t9;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  return t14;
}
function _temp(role) {
  return {
    title: formatUserRoleType(role),
    subtitle: userRoleDescription(role),
    value: role
  };
}